import api from './axios.js';

export const messagesApi = {
  getByContact: (contactId, params) => api.get(`/messages/contact/${contactId}`, { params }),
  send: (data) => api.post('/messages/send', data),
  quickSend: (data) => api.post('/messages/quick-send', data),
  markRead: (id) => api.put(`/messages/${id}/read`),
  markContactRead: (contactId) => api.put(`/messages/contact/${contactId}/read`),
  markAllRead: () => api.put('/messages/read-all'),
  delete: (id) => api.delete(`/messages/${id}`),
  exportAll: (params) => api.get('/messages/export-all', { params, responseType: 'blob' }),
  export: (contactId, params) => api.get(`/messages/export/${contactId}`, { params, responseType: 'blob' }),
};
